namespace Ir.Components.Workbook.ToolBar.CopyTabAnotherWorkbook {
    interface IViewModel {
        buttonOptions: DevExpress.ui.dxButton.Properties,
        previousOptions: DevExpress.ui.dxButton.Properties,
        confirmOptions: DevExpress.ui.dxButton.Properties,
        popupOptions: DevExpress.ui.dxPopup.Properties,
        multiViewOptions: DevExpress.ui.dxMultiView.Properties,

        pageTitle: KnockoutObservable<string>,
        previousVisible: KnockoutObservable<boolean>,
        confirmDisabled: KnockoutObservable<boolean>,
        multiViewSelectionIndex: KnockoutObservable<number>,
        dataSource: KnockoutObservableArray<any>,
        selectedTabs: KnockoutObservableArray<number>,

        popupComponent: DevExpress.ui.dxPopup,

        selectedWorkbook: SimpleWorkbookVM,
        tabWidgetDependencies: Array<any>
    }

    export function getViewModel(this: IViewModel, params: any, componentInfo) {
        let self = this;
        this.confirmDisabled = ko.observable(true);
        this.previousVisible = ko.observable(false);
        this.multiViewSelectionIndex = ko.observable(0);
        this.dataSource = ko.observableArray([]);
        this.selectedTabs = ko.observableArray([]);
        this.pageTitle = ko.observable("Select a Workbook");
        
        this.buttonOptions = {
            hint: 'Copy tabs from another Workbook',
            template: `<i class="ms ms-white ms-bold">add</i> Copy`,
            stylingMode: 'contained',
            type: 'default',
            onClick(e) {
                self.popupComponent.show();
            },
            visible: workbook.workbookConfig.generalSettings.editing as any
        };

        this.previousOptions = {
            text: "Previous",
            stylingMode: 'contained',
            type: 'normal',
            onClick(e) {
                reset(self);
            },
            visible: this.previousVisible as any
        };

        this.confirmOptions = {
            text: "Confirm",
            stylingMode: 'contained',
            type: 'default',
            onClick() {
                save(self);
            },
            disabled: self.confirmDisabled as any
        };
                
        this.multiViewOptions = {
            width: "100%",
            height: "calc(100% - 35px)",
            swipeEnabled: false,
            items: getItemsMultiView(self),
            selectedIndex: self.multiViewSelectionIndex as any,
            onSelectionChanged(e) {
                self.pageTitle(e.addedItems[0].text)
            }
        };

        this.popupOptions = {
            title: "Copy Tab from another Workbook",
            visible: false,
            width: 500,
            height: 500,
            onInitialized(e) {
                self.popupComponent = e.component;
            },
            onHidden(e) {
                reset(self);
            }
        };
    }

    function reset(self: IViewModel) {
        self.dataSource([]);
        self.selectedTabs([]);
        self.multiViewSelectionIndex(0);
        self.previousVisible(false);
        self.confirmDisabled(true);
    }

    function getItemsMultiView(self: IViewModel) {
        return [
            {
                text: "Select a Workbook",
                template: function () {
                    let workbookList = $(`<workbook-list params="onClick: onClick, onFiltering: onFiltering, selectionMode: selectionMode"><\workbook-list>`);
                    ko.applyBindings({
                        onClick(workbook: SimpleWorkbookVM) {
                            self.selectedWorkbook = workbook;
                            getTabs(self);
                            self.confirmDisabled(false);
                            self.previousVisible(true);
                            self.multiViewSelectionIndex(1);
                        },
                        onFiltering(workbooks: Array<SimpleWorkbookVM>) {
                            return workbooks.filter(x => x.mappingId === workbook.workbookConfig.mappingId && x.id !== workbook.workbookConfig.workbookId());
                        },
                        selectionMode: "none"
                    }, workbookList.get(0));
                    return workbookList;
                }
            },
            {
                text: "Select tabs to copy",
                template: function () {
                    let $div = $(`<div data-bind="dxDataGrid: tabsOptions"></div>`);
                    ko.applyBindings({
                        tabsOptions: {
                            keyExpr: "id",
                            dataSource: self.dataSource,
                            columns: [
                                { dataField: "id", visible: false },
                                { dataField: "name", caption: "Tab Name" },
                            ],
                            height: "100%",
                            selection: {
                                mode: 'multiple',
                                showCheckBoxesMode: 'always'
                            },
                            selectedRowKeys: self.selectedTabs,
                            showBorders: true,
                            paging: {
                                enabled: false
                            },
                            onSelectionChanged: function (e) {
                                if (e.currentSelectedRowKeys.length > 0) {
                                    let selectRows = [];
                                    e.currentSelectedRowKeys.forEach(function (key) {
                                        if (self.tabWidgetDependencies[key]) {
                                            self.tabWidgetDependencies[key].forEach(function (tabId) {
                                                if (selectRows.indexOf(tabId) === -1 && e.selectedRowKeys.indexOf(tabId) === -1) {
                                                    selectRows.push(tabId);
                                                }
                                            });
                                        }
                                    });

                                    if (selectRows.length > 0) {
                                        e.component.selectRows(selectRows, true);
                                    }
                                }
                            }
                        }
                    }, $div.get(0));
                    return $div;
                }
            },
        ];
    }

    function getTabs(self: IViewModel) {
        let o = {
            url: urlConfigs.tabs + "GetWorbookTabsToCopy",
            data: {
                workbookId: self.selectedWorkbook.id,
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data: { tabs: Array<{ id: number, name: string }>, tabWidgetDependencies: any }) {
            self.selectedTabs([]);
            self.dataSource(data.tabs);
            self.tabWidgetDependencies = data.tabWidgetDependencies;
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to get tabs from another workbook`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    function save(self: IViewModel) {
        if (self.selectedTabs().length === 0) {
            DevExpress.ui.notify("Select at least one tab to be copied");
            return;
        }

        let o = {
            url: urlConfigs.tabs + "CopyTabsFromAnotherWorkbook",
            data: {
                workbookId: workbook.workbookConfig.workbookId(),
                fromWorkbookId: self.selectedWorkbook.id,
                tabs: self.selectedTabs()
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data: { tabs: Array<any> }) {
            let newTabsDS: Array<WorkbookTabDataSourceVM> = [];
            for (let tab of data.tabs) {
                let newTab = new WorkbookTab(tab, workbook.workbookConfig);
                workbook.workbookConfig.tabs.push(newTab);

                let newTabDataSource = new WorkbookTabDataSourceVM({
                    iconClass: newTab.tabType() === TabTypeEnum.Dashboard ? "mi" : "ms",
                    title: newTab.name(),
                    tab: newTab,
                    order: workbook.workbookConfig.workbookHelper.workbookTabsDataSource().length + 1
                });

                newTabsDS.push(newTabDataSource);
            }

            Ir.Components.Workbook.WorkbookTabs.addTabs(newTabsDS, workbook.workbookConfig.workbookHelper);

            self.popupComponent.hide();
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to copy tabs from another workbook`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
}